import React from 'react';
import '../css/navbar.scss';
import {NavDropdown} from "react-bootstrap";
import { LanguageList } from "../../enums/Languages";

export default class NavLanguageComponent extends React.Component {

    changeLanguage = lang => {
        sessionStorage.setItem('language', lang);
    };

    changeLanguageUrl = lang => {
        if(this.props.language !== lang) {
            let path = window.location.pathname;
            return path.replace(this.props.language, lang);
        }
    };

    render() {
        const { language } = this.props;

        return (
            <NavDropdown
                id="language-dropdown"
                title={(
                    <>
                        <i className="fa fa-language"/> {LanguageList.find((lang) => lang.value === language).label || 'Unknown'}
                    </>
                )}>
                {LanguageList.map((lang) => (
                    <NavDropdown.Item
	                    key={lang.value}
	                    onClick={() => this.changeLanguage(lang.value)} href={this.changeLanguageUrl(lang.value)}
                    >
                        {lang.label}
                    </NavDropdown.Item>
                ))}
            </NavDropdown>
        );
    }
}
